export default __webpack_public_path__ + "static/media/right-bg.1076d6ea.jpg";